import { render, staticRenderFns } from "./AdminCharts.vue?vue&type=template&id=a4af82e0&"
import script from "./AdminCharts.vue?vue&type=script&lang=ts&"
export * from "./AdminCharts.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCharts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports